
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 136.263 90.842"}, attrs),
              ...rest,
            },
            children.concat([_c('defs',[_c('linearGradient',{attrs:{"id":"a","x1":".01","y1":".531","x2":"1","y2":".559","gradientUnits":"objectBoundingBox"}},[_c('stop',{attrs:{"offset":"0","stop-color":"#218665"}}),_c('stop',{attrs:{"offset":"1","stop-color":"#218665"}})])]),_c('path',{attrs:{"d":"M14.194 85.333h107.875a14.194 14.194 0 0114.194 14.194v62.454a14.194 14.194 0 01-14.194 14.194H14.194A14.194 14.194 0 010 161.981V99.527a14.194 14.194 0 0114.194-14.194z","transform":"translate(0 -85.333)","fill":"url(#a)"}}),_c('path',{attrs:{"fill":"#74dbb5","d":"M0 17.033h136.263v22.71H0z"}}),_c('path',{staticClass:"c",attrs:{"d":"M42.582 62.454h-22.71a2.839 2.839 0 010-5.678h22.71a2.839 2.839 0 010 5.678zM59.615 73.809H19.872a2.839 2.839 0 010-5.678h39.743a2.839 2.839 0 010 5.678z"}})])
          )
        }
      }
    